export default __webpack_public_path__ + "static/MaxPack-fa058471e81a130622bc81b2963bbf64.mp4";